export default [
    {
      image: "https://www.airasia.com/aa/ride/benefits/images/Driver_Incentive_Widget_carousel_580x360.jpg",
      title: "Earn up to RM200 weekly",
      url:"https://www.airasia.com/aa/about-us/en/gb/ride-terms-and-conditions.html#IncentivesProgram"
    }
  ]

